import { motion, AnimateSharedLayout } from 'framer-motion'

// Components
import { Button, Link } from '@tracklib/kit'
import Offer from 'components/subscribe/offer'
import Card from 'components/subscribe/card'
import Faq from 'components/subscribe/faq'

// Hooks
import { useStaticPageByPath } from 'modules/staticpages/hooks'

// Types
import { TierOffer } from 'types'

import styles from './chooseplan.css'

type ChoosePlanProps = {
  offers: Array<TierOffer>
  selectedOfferId: number | null | undefined
  selectedMonths: number | null | undefined
  setSelectedMonths: (selectedMonths: number) => void
}

const ChoosePlan = ({ offers, selectedMonths, selectedOfferId, setSelectedMonths }: ChoosePlanProps): JSX.Element => {
  const selectedOffer = offers?.find(({ id }) => id === selectedOfferId)
  const periods = selectedOffer?.tier.periods || (offers?.length && offers[0].tier.periods) || [] // if no chosen offer just select the first
  const selectedPeriod = periods?.find(({ months }) => months === selectedMonths)

  const { page } = useStaticPageByPath('subscribe')
  const faqBlock = page?.content.find(x => x.type === 'faq')
  const perks = page?.content.find(x => x.type === 'offer')?.value.perks

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.periodButtons}>
          <AnimateSharedLayout transition={{ duration: 0.2 }}>
            {periods
              .sort((a, b) => a.months - b.months)
              .map(({ months, id, label }) => {
                const selected = months === selectedMonths
                return (
                  <Button
                    key={id}
                    className={selected ? styles.periodButtonSelected : styles.periodButton}
                    onClick={() => setSelectedMonths(months)}
                    datatesting={`button_period_months_${months}`}
                  >
                    {selected && <motion.span layoutId="background" className={styles.periodButtonSelectedBackground} />}
                    {label && <span className={styles.label}>{label}</span>}
                  </Button>
                )
              })}
          </AnimateSharedLayout>
        </div>
        <p className={styles.periodText}>Get 2 months free when you pay annually</p>

        <div className={styles.offers}>
          {offers
            .sort((a, b) => a.tier.ordering - b.tier.ordering)
            .map(({ id, tier }) => {
              const selectedPeriodForOffer =
                tier.periods.find(x => x.months === selectedPeriod?.months) || tier.periods.sort((a, b) => b.months - a.months)[0]
              return <Offer key={id} selected={id === selectedOfferId} tier={tier} period={selectedPeriodForOffer} perks={perks} />
            })}
        </div>
        <p className={styles.limitedPlan}>
          If you don’t want a free trial and just want to manage your Tracklib licenses, sign up for our limited plan by{' '}
          <Link to="freeplan" modal>
            clicking here
          </Link>
          .
        </p>
      </div>
      {faqBlock && (
        <Card size="large">
          <Faq title={faqBlock.value.title} questions={faqBlock.value.questions} />
        </Card>
      )}
    </>
  )
}

export default ChoosePlan
